/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiTileShape {
    Rectangular = 'RECTANGULAR',
    HexagonalRegular = 'HEXAGONAL_REGULAR',
    TriangularRightAngle = 'TRIANGULAR_RIGHT_ANGLE',
    TriangularIsosceles = 'TRIANGULAR_ISOSCELES'
}

export function ApiTileShapeFromJSON(json: any): ApiTileShape {
    return ApiTileShapeFromJSONTyped(json, false);
}

export function ApiTileShapeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTileShape {
    return json as ApiTileShape;
}

export function ApiTileShapeToJSON(value?: ApiTileShape | null): any {
    return value as any;
}

